import React from 'react';
import { AlertCircle, CheckCircle, Clock, FileText, RefreshCw } from 'lucide-react';

const StatusBadge = ({ status, reviewDecision = 'none', legacyRejected = false, className = '' }) => {
  const normalizedStatus = status === 'legacy-rejected' || status === 'incomplete'
    ? 'in-progress'
    : status;

  const statusConfig = {
    'assigned': {
      label: 'Assigned',
      color: 'bg-blue-100 text-blue-800',
      icon: FileText
    },
    'in-progress': {
      label: 'In Progress',
      color: 'bg-blue-100 text-blue-700',
      icon: Clock
    },
    'review-pending': {
      label: 'Review Pending',
      color: 'bg-amber-100 text-amber-800',
      icon: RefreshCw
    },
    'incomplete': {
      label: 'Rejected (Legacy)',
      color: 'bg-red-100 text-red-700',
      icon: AlertCircle
    },
    'legacy-rejected': {
      label: 'Rejected (Legacy)',
      color: 'bg-red-100 text-red-700',
      icon: AlertCircle
    },
    'completed': {
      label: 'Completed',
      color: 'bg-green-100 text-green-800',
      icon: CheckCircle
    }
  };

  const config = statusConfig[normalizedStatus] || statusConfig['assigned'];
  const Icon = config.icon;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color} ${className}`}>
      <Icon className="h-3 w-3 mr-1" />
      {config.label}
    </span>
  );
};

export default StatusBadge;
